import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { ensureUrl } from '../lib/profileData';

const FeaturedLinks = ({ links }) => {
  if (!links?.length) return null;

  return (
    <div className="px-5 mt-8">
      <p className="text-black font-semibold text-lg">Featured</p>
      <div className="mt-3 flex flex-col gap-5">
        {links.map((item, index) => (
          <a
            key={index}
            href={ensureUrl(item.url)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="rounded-md bg-black flex items-center gap-3 px-2 cursor-pointer py-2 text-white">
              <span className="w-10 h-10 sm:w-14 sm:h-14 flex items-center justify-center">
                <FontAwesomeIcon icon={faGlobe} className="w-full h-full text-white" />
              </span>
              <p className="text-white text-sm sm:text-base">{item.label}</p>
            </span>
          </a>
        ))}
      </div>
    </div>
  );
};

export default FeaturedLinks;
